import { getList, publicPage } from './getAnswerSheetList'
import { deepClone } from '@/assets/js/utils'
import { answerSettleAdjust, settlementCreate, getAnswerInterviewers } from '@/api/wenjuan/settlement'
import GlobalConfig from '@/global/config'
import { SURVEY_PUBLISH_STATUS } from '@/global/config-variable'

export default {
  props: {
    queryForm: {
      type: Object,
      default: () => ({})
    },
    opt: {
      type: Object,
      default: () => ({})
    },
    settleType: {
      // 0=委托方页面,1=代理页面,2=面访页面
      type: Number,
      default: 0
    },
    searchField: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      queryFields: [],
      headerList: [
        {
          text: '待结算金额（元）',
          value: 'pendingAmount'
        },
        {
          text: '正在结算金额（元）',
          value: 'settlingAmount'
        },
        {
          text: '已结算金额（元)',
          value: 'settledAmount'
        }
      ],
      settlementId: '',
      drawer: false,
      sentData: {},
      dialogSettlementBillTitle: '生成结算单确认',
      dialogSettlementBillVisible: false,
      dialogTitle: '调整单价',
      dialogVisible: false,
      dialogUnitPrice: '',
      dialogType: '',
      sheetNum: 0,
      sheetAmountSum: 0,
      totalYuanAmount: 0,
      visitorNum: 0,
      dialogForm: {
        realAmount: '',
        adjustDescribe: ''
      },
      rules: {
        realAmount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^([1-9]\d{0,7}|0)(\.\d{1,2})?$/,
            message: '请输入有效的的金额'
          }
        ],
        adjustDescribe: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      selectionList: [],
      selectionAmountList: [],
      selectionSingleAmountList: [],
      statusFlag: true,
      forms: {},
      page: publicPage,
      option: this.opt,
      data: []
    }
  },
  methods: {
    //全部结算
    toSettlementAll() {
      this.$confirm('确定全部结算吗？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'confirm-box',
        showClose: false,
        type: 'warning'
      })
        .then(() => {
          const fs = deepClone(this.forms)
          fs.surveyId = GlobalConfig.getSurveyId()
          fs.settleType = this.settleType
          settlementCreate(fs)
            .then(res => {
              this.commonChange()
              this.$message({
                showClose: true,
                message: '生成成功',
                type: 'success'
              })
              this.toSettlementBillList()
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: '生成失败',
                type: 'error'
              })
            })
        })
        .catch(() => {})
    },
    openDrawer(row) {
      this.settlementId = row.statementId
      this.drawer = true
      this.$nextTick(function () {
        this.$refs.detailDrawer.getSettlementDetail()
      })
    },
    generateSettlementBill() {
      if (this.selectionList.length == 0) {
        this.$message.error('未选择答卷')
        return
      }
      if (!this.statusFlag) {
        this.$message.error('含有已生成结算单的答卷，请检查')
        return
      }
      this.dialogSettlementBillVisible = true
    },
    createSettlement() {
      let params = {
        settleType: this.settleType,
        surveyId: GlobalConfig.getSurveyId(),
        answerIds: this.selectionList
      }
      settlementCreate(params)
        .then(res => {
          this.dialogSettlementBillVisible = false
          this.commonChange()
          this.$message({
            showClose: true,
            message: '生成成功',
            type: 'success'
          })
          this.toSettlementBillList()
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: '生成失败',
            type: 'error'
          })
        })
    },
    toSettlementBillList() {
      let pathStr = ''
      if (this.settleType === 0) {
        pathStr = 'proxy'
      } else if (this.settleType === 1) {
        pathStr = 'visitor'
      } else if (this.settleType === 2) {
        pathStr = 'offline'
      } else if (this.settleType === 3) {
        pathStr = 'phone'
      }
      this.$router.push({
        path: '/survey/' + GlobalConfig.getSurveyId() + '/settlement/settlement-' + pathStr + '/list',
        query: {
          settleType: this.settleType
        }
      })
    },
    showDialog(row, bach) {
      console.log('row', row)
      if (bach == 'bach') {
        this.dialogTitle = '批量调价'
        let array = [...new Set(this.selectionSingleAmountList)]
        this.dialogUnitPrice = array.join(',')
        this.dialogType = 'bach'
      } else if (bach == 'all') {
        this.dialogTitle = '全部调价'
        this.dialogType = 'all'
      } else {
        this.dialogTitle = '调整单价'
        this.dialogUnitPrice = row.singleAmount
        this.dialogType = 'single'
      }
      this.dialogVisible = true
      let data = {
        settleType: this.settleType,
        surveyId: GlobalConfig.getSurveyId(),
        answerIds: [row.answerId]
      }
      // 是否批量
      if (bach == 'bach') {
        data.answerIds = this.selectionList
      } else if (bach == 'all') {
        data.answerIds = []
      }
      this.sentData = data
    },
    showDialogBatch(bach) {
      if (bach == 'bach') {
        if (this.selectionList.length > 0) {
          this.showDialog({}, bach)
        } else {
          this.$message.error('批量操作前请先进行选择')
        }
      } else if (bach == 'all') {
        this.showDialog({}, bach)
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs['dialogForm'].clearValidate()
      Object.assign(this.$data.dialogForm, this.$options.data().dialogForm)
    },
    handleSettlementBillClose() {
      this.dialogSettlementBillVisible = false
    },
    SelectionChange(val) {
      this.statusFlag = true
      this.selectionList = val.map(el => {
        if (el.settleStatus != 0) {
          this.statusFlag = false
        }
        return el.answerId
      })
      let num = 0
      let i = 0
      let selectionVisitorList = []
      this.selectionSingleAmountList = []
      this.selectionAmountList = val.map(el => {
        selectionVisitorList.push(el.executorId)
        this.selectionSingleAmountList.push(el.singleAmount)
        num = num + Number(el.realAmount)
        i++
        return el.realAmount
      })
      this.sheetAmountSum = num.toFixed(2)
      this.sheetNum = i
      this.visitorNum = [...new Set(selectionVisitorList)].length
      console.log('this.selectionList', this.selectionList)
    },
    // 问卷调价
    editMoney() {
      this.$refs['dialogForm'].validate(valid => {
        if (valid) {
          let data = this.sentData
          data.realYuanAmount = this.dialogForm.realAmount
          data.adjustDescribe = this.dialogForm.adjustDescribe
          answerSettleAdjust(data)
            .then(res => {
              if (res.data.code != 0) {
                this.$message.error(res.data.msg)
                return
              }
              this.dialogVisible = false
              Object.assign(this.$data.dialogForm, this.$options.data().dialogForm)
              this.$refs.tableRef.clearSelection()
              this.sheetAmountSum = 0
              this.commonChange()
              this.$message({
                showClose: true,
                message: '调价成功',
                type: 'success'
              })
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: '调价失败',
                type: 'error'
              })
            })
        } else {
          return false
        }
      })
    },
    getList(params) {
      getList.call(this, params)
    },
    // 整理请求数据
    handleData() {
      const fs = deepClone(this.forms)
      fs.current = this.page.currentPage
      fs.size = this.page.pageSize
      fs.surveyId = GlobalConfig.getSurveyId()
      fs.settleType = this.settleType
      // Object.keys(params).forEach((key) => {
      //   // 0 不删除
      //   if (!params[key] && params[key] !== 0) {
      //     delete params[key]
      //   }
      // })
      return fs
    },
    commonChange() {
      this.getList(this.handleData())
      this.getHList({
        surveyId: GlobalConfig.getSurveyId(),
        settleType: this.settleType
      })
    },
    onChangeSearchField(params) {
      if (params.executorIds) {
        params.executorIds = params.executorIds.join(',')
      }
      if (params.auditTimeMin) {
        params.auditTimeBegin = params.auditTimeMin
        delete params.auditTimeMin
      }
      if (params.auditTimeMax) {
        params.auditTimeEnd = params.auditTimeMax
        delete params.auditTimeMax
      }
      this.forms = params
      this.page.currentPage = 1
      this.commonChange()
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      //   重新渲染
      this.commonChange()
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      //   重新渲染
      this.commonChange()
    },
    refreshHead() {
      this.getHList({
        surveyId: GlobalConfig.getSurveyId(),
        settleType: this.settleType
      })
    },
    //维度切回答卷时刷新
    pageChange(val) {
      if (val) {
        this.commonChange()
      }
    },
    init() {
      this.page = {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        pageSizes: [10, 20, 30, 50, 100]
      }
      this.commonChange()
    },
    getAnswerInterviewers() {
      let params = {
        surveyId: GlobalConfig.getSurveyId(),
        settleType: this.settleType
      }
      getAnswerInterviewers(params)
        .then(res => {
          let data = res.data.data
          this.searchField[1].options = data.map(item => {
            let opItem = {}
            opItem.label = item.name || item.phone
            opItem.value = item.id
            return opItem
          })
          this.queryFields = deepClone(this.searchField)
        })
        .catch(err => {})
    }
  },
  created() {
    this.forms = this.queryForm
    // if(this.$store.getters.publishStatus === SURVEY_PUBLISH_STATUS.UNPUBLISHED) {
    //   this.$message.error('问卷未发布，无法使用结算')
    //   this.queryFields = deepClone(this.searchField)
    //   return
    // }
    if (this.settleType == 2 || this.settleType == 3) {
      this.getAnswerInterviewers()
    } else {
      this.queryFields = deepClone(this.searchField)
    }
    this.init()
  }
}
